import * as React from 'react';
import RevenuesCore from '../AfrCore/RevenuesCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const RevenuesA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <RevenuesCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default RevenuesA;